import Vue from 'vue';
import Vuex from 'vuex';
import apiStateModule from './modules/apiState';
import chatModule from './modules/chat';
import profileModule from './modules/profile';
import socketModule, { initializeSocketModule } from './modules/socket';
import router from '@/router';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    apiState: apiStateModule,
    chat: chatModule,
    profile: profileModule,
    socket: socketModule,
  },
  actions: {
    async logout ({commit, dispatch}, forceLogoutMessage) {
      localStorage.removeItem('jwtToken');

      commit('FORCE_LOGOUT_MESSAGE', forceLogoutMessage);

      //cleanup
      dispatch('closeSocket');
      commit('PROFILE_LOADED', {});
      commit('SELECTED_PROFILE_LOADED', {});
      commit('ALL_PROFILES_LOADED', []);
      commit('CHAT_LOGOUT');
      router.push('/login');
    },
  },
});

initializeSocketModule(store);

store.watch(
  (state, getters) => [getters.profile.userId, getters.connected, getters.loginCounter],
  ([userId, connected], [previousUserId] = []) => {
    if (!localStorage.jwtToken) {
      return;
    }

    if (!userId) {
      store.dispatch('getProfile');
      return;
    }

    if (!connected || userId !== previousUserId) {
      store.dispatch('connectSocket');
      return;
    }

    store.dispatch('getChats');
  },{
    immediate: true,
  }
);

export default store;
